import { render, staticRenderFns } from "./ContentSpreadCheckbox.vue?vue&type=template&id=dcf23bb8&"
import script from "./ContentSpreadCheckbox.vue?vue&type=script&lang=js&"
export * from "./ContentSpreadCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports